import { useMemo } from 'react';

import { useIsQuestionsOnlyMode } from '../../featureChecks';
import { UseMainUIFeatureSettings, uiFeatureAccessSymbol } from '../../types';

export const useThreadPageSettings: UseMainUIFeatureSettings<'threadPage'> = (options) => {
  const threadPageOverrides = options?.overrides?.threadPage;

  const isQuestionsOnlyMode = useIsQuestionsOnlyMode();

  return useMemo(() => {
    if (isQuestionsOnlyMode) {
      return {
        [uiFeatureAccessSymbol]: true,
        groupsExplorerCard: false,
        toolbarFollow: false,
        toolbarMarkAsRead: false,
        ...threadPageOverrides,
      };
    }

    return {
      [uiFeatureAccessSymbol]: true,
      groupsExplorerCard: false,
      toolbarFollow: true,
      toolbarMarkAsRead: true,
      ...threadPageOverrides,
    };
  }, [isQuestionsOnlyMode, threadPageOverrides]);
};
